import { useEffect, useState } from "react";
import BotaoContato from "../../componentes/BotaoContato/BotaoContato.js";
import "../ServicosEngAplicadaProjTec/ServicosEngAplicadaProjTec.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";
import Servicos from "../Servicos/Servicos.js";

function ServicosCapacitacaoETreinamento() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div>
      <BannerPaginaInterna
        tag="Capacitação e Treinamento Ambiental"
        titulo="Capacitação e Treinamento Ambiental"
        descricao="As capacitações são desenvolvidas de forma personalizada, considerando as características do empreendimento, os requisitos normativos e os objetivos estratégicos do cliente."
        textoBotao="Solicitar Orçamento"
        rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento para Capacitação e Treinamento Ambiental"
        mostrarBotaoOutline={true}
        textoBotaoOutline="Fale com Especialista"
        rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista em capacitação e treinamento ambiental"
      />

      <main className="servicos-page py-5">
        {/* HEADER */}

        {/* LISTA COM DETAILS */}
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>Nossos Serviços Especializados</h2>
            <p>
              Clique nos itens abaixo para conhecer detalhes de nossa atuação
              técnica.
            </p>
          </div>

          <p>
            A Âmbar Soluções em Engenharia e Meio Ambiente oferece serviços de{" "}
            <strong>capacitação e treinamento ambiental</strong>, voltados para
            empresas, equipes operacionais e comunidades, com foco na{" "}
            <strong>
              conformidade legal, conscientização ambiental e melhoria do
              desempenho operacional
            </strong>
            .
          </p>

          <p className="mb-4">
            As capacitações são desenvolvidas de forma personalizada,
            considerando as características do empreendimento, os requisitos
            normativos e os objetivos estratégicos do cliente.
          </p>

          <div className="accordion">
            <div className="accordion">
              {/* ITEM 08 */}
              <details
                className="item"
                open={openItem === 8}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 8 ? null : 8);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Execução de Programas de Educação Ambiental (PEA)
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Realizamos a estruturação e execução de{" "}
                      <strong>Programas de Educação Ambiental (PEA)</strong>,
                      conforme exigências de{" "}
                      <strong>processos de licenciamento ambiental</strong>.
                      <br />
                      Os programas são desenvolvidos com base em{" "}
                      <strong>diretrizes técnicas</strong> e
                      <strong> metodologias participativas</strong>, promovendo{" "}
                      <strong>sensibilização ambiental</strong>,
                      <strong> engajamento social</strong> e cumprimento de{" "}
                      <strong>condicionantes ambientais</strong>.
                      <br />
                      Atuamos tanto na <strong>elaboração</strong> quanto na{" "}
                      <strong>execução</strong> das atividades, incluindo{" "}
                      <strong>
                        registro e comprovação junto aos órgãos ambientais
                      </strong>
                      .
                    </p>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Programas de Educação Ambiental (PEA)"
                    />
                  </div>
                </div>
              </details>

              {/* ITEM 09 */}
              <details
                className="item"
                open={openItem === 9}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 9 ? null : 9);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Treinamento em gerenciamento de resíduos
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Oferecemos{" "}
                      <strong>
                        treinamentos técnicos em gerenciamento de resíduos
                        sólidos
                      </strong>
                      , abordando desde a <strong>segregação</strong> até a{" "}
                      <strong>destinação final adequada</strong>.
                      <br />
                      Os conteúdos são alinhados à{" "}
                      <strong>legislação vigente</strong> e às
                      <strong> práticas operacionais</strong>, garantindo que as
                      equipes estejam capacitadas para atuar de forma{" "}
                      <strong>segura</strong> e conforme as{" "}
                      <strong>exigências ambientais</strong>.
                    </p>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Treinamento em Gerenciamento de Resíduos"
                    />
                  </div>
                </div>
              </details>

              {/* ITEM 10 */}
              <details
                className="item"
                open={openItem === 10}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 10 ? null : 10);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Atendimento a PCS (Plano de Comunicação Social)
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Desenvolvemos e executamos ações vinculadas ao
                      <strong> Plano de Comunicação Social (PCS)</strong>, com
                      foco na
                      <strong> comunicação transparente</strong> entre
                      empreendimento e partes interessadas.
                      <br />
                      As atividades incluem <strong>planejamento</strong>,{" "}
                      <strong>execução</strong> e
                      <strong> registro de ações de comunicação</strong>,
                      garantindo o atendimento às
                      <strong> exigências de licenciamento</strong> e
                      fortalecendo o
                      <strong> relacionamento institucional</strong>.
                    </p>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Plano de Comunicação Social (PCS)"
                    />
                  </div>
                </div>
              </details>

              {/* ITEM 11 */}
              <details
                className="item"
                open={openItem === 11}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 11 ? null : 11);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Oficinas e ações para comunidades e empresas
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Promovemos{" "}
                      <strong>oficinas, palestras e ações educativas</strong>{" "}
                      voltadas para
                      <strong> comunidades</strong> e{" "}
                      <strong>equipes corporativas</strong>, com foco em
                      <strong> temas ambientais</strong>,{" "}
                      <strong>sustentabilidade</strong> e
                      <strong> boas práticas operacionais</strong>.
                      <br />
                      As atividades são estruturadas de forma{" "}
                      <strong>prática e acessível</strong>, contribuindo para o
                      <strong> engajamento</strong>,{" "}
                      <strong>conscientização</strong> e fortalecimento da
                      <strong> responsabilidade socioambiental</strong>.
                    </p>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Oficinas e Ações Ambientais"
                    />
                  </div>
                </div>
              </details>

              {/* ITEM 12 */}
              <details
                className="item"
                open={openItem === 12}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenItem(openItem === 12 ? null : 12);
                }}
              >
                <summary className="item-summary">
                  <div className="item-header">
                    <p className="item-titulo">
                      Elaboração de materiais didáticos e capacitações em NRs
                    </p>
                  </div>
                  <span className="icone">
                    <i className="fa-solid fa-chevron-down"></i>
                  </span>
                </summary>

                <div className="item-conteudo">
                  <div className="bloco-descricao-servico">
                    <p>
                      Desenvolvemos <strong>materiais didáticos</strong> e{" "}
                      <strong>treinamentos técnicos</strong>, incluindo
                      capacitações relacionadas às{" "}
                      <strong>Normas Regulamentadoras (NRs)</strong>.
                      <br />
                      Os conteúdos são elaborados de forma{" "}
                      <strong>clara e técnica</strong>, garantindo a
                      <strong> compreensão dos requisitos legais</strong> e a
                      <strong>
                        {" "}
                        aplicação prática no dia a dia operacional
                      </strong>
                      .
                    </p>

                    <BotaoContato
                      texto="Entre em Contato"
                      rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Capacitações e NRs"
                    />
                  </div>
                </div>
              </details>
            </div>
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ServicosCapacitacaoETreinamento;
